import { useMemo, useState, Fragment } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Image } from 'foundations-components/transitional/components/Image';
import { View } from 'foundations-components/components/View';
import { H2 } from 'foundations-components/transitional/components/H2';
import { HR } from 'foundations-components/transitional/components/HR';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { AddIcon, SprocketIcon } from 'foundations-assets';
import ScopesAuthorization from 'developer-experience-shared-components/scopes/v3/components/ScopesAuthorization';
import * as ScopeGroupType from '../../../common/constants/scopes/ScopeGroup';
import { View as FoundationsView } from 'foundations-components/transitional/components/View';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const RequiredPermissions = ({
  appName,
  connectionType,
  homemade,
  iconUrl,
  neededScopeGroups,
  trackInteraction
}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const filteredScopeGroups = useMemo(() => {
    return neededScopeGroups && neededScopeGroups.filter(scope => {
      return scope.name !== ScopeGroupType.OAUTH;
    });
  }, [neededScopeGroups]);
  const descriptionText = useMemo(() => {
    if (homemade && connectionType !== 'STANDARD') {
      return /*#__PURE__*/_jsx(Tooltip, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-ui-apps-core.detail.sidebar.requirements.permissions.subheadingText.homemadeAppTooltip"
        }),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-ui-apps-core.detail.sidebar.requirements.permissions.subheadingText.homemadeAppPermissions"
        })
      });
    } else if (!filteredScopeGroups.length) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-ui-apps-core.detail.sidebar.requirements.permissions.subheadingText.noRequiredPermissions",
        options: {
          appName
        }
      });
    } else {
      return /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "marketplace-ui-apps-core.detail.sidebar.requirements.permissions.subheadingText.viewPermissions_jsx",
        elements: {
          Link
        },
        options: {
          onClick: () => {
            setModalOpen(true);
            trackInteraction('click required account permissions');
          }
        }
      });
    }
  }, [appName, homemade, connectionType, filteredScopeGroups, trackInteraction]);
  const modal = useMemo(() => /*#__PURE__*/_jsxs(Modal, {
    width: 500,
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-ui-apps-core.detail.sidebar.requirements.permissions.modal.header"
        })
      }), /*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: () => setModalOpen(false)
      })]
    }), /*#__PURE__*/_jsxs(DialogBody, {
      paddingBlockEnd: "1100",
      children: [/*#__PURE__*/_jsxs(TFlex, {
        align: "center",
        justify: "center",
        paddingBlock: "400",
        children: [/*#__PURE__*/_jsx(Image, {
          alt: appName,
          src: iconUrl,
          maxBlockSize: "60px"
        }), /*#__PURE__*/_jsx(FoundationsView, {
          as: "span",
          paddingInline: "400",
          children: /*#__PURE__*/_jsx(AddIcon, {
            color: "do-not-use-flint",
            size: "600"
          })
        }), /*#__PURE__*/_jsx(SprocketIcon, {
          color: "do-not-use-lorax",
          size: "900"
        })]
      }), /*#__PURE__*/_jsx(View, {
        textAlign: "center",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-ui-apps-core.detail.sidebar.requirements.permissions.modal.subtitle",
          options: {
            appName
          }
        })
      }), /*#__PURE__*/_jsx(HR, {}), /*#__PURE__*/_jsx(ScopesAuthorization, {
        scopes: filteredScopeGroups
      })]
    })]
  }), [appName, iconUrl, filteredScopeGroups]);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [descriptionText, modalOpen && modal]
  });
};